<template>
  <div class="q-nps-ba-container main-color">
      <label v-html="question.q" class="q-label"></label>
    <div v-if="visible === true" style="width:100%;">
      <label class="nps_label">{{question.begin_text}}</label>
      <label class="nps_label" style="text-align:right;">{{question.end_text}}</label>
    </div>
    <div v-show="visible === true" style="width:100%; display:flex; flex-direction:row;">
      <label ref="options" v-for="option in question.answers" :key="option.value" :value="option.value" class="label_nps_tigo" style="width:100%;" v-on:click="selectNPS">{{ option.value }}</label>
    </div>
    <div style="width:100%">
      <md-checkbox v-on:change="clickNaText" v-model="checked">{{ question.na_text }}</md-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  name: "nps-ba-question",
  props: {
    question: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data: function() {
    return {
      answer: "",
      checked: false,
      visible: true
    };
  },
  computed: {
    myComputedWidth() {
      return Math.round(100 / ((this.question.max - this.question.min)+1));
    }
  },
  methods: {
    selectNPS: function(event) {
      //put to all elements the same class
      this.formatNPSInitial();

      //set the selected document
      event.target.classList.remove("label_nps_1");
      event.target.classList.remove("label_nps_2");
      event.target.classList.remove("label_nps_3");
      event.target.classList.add("label_nps_selected");
      this.answer = event.target.innerText;
      //console.log(event.target.innerText);
      //console.log(event.target);
      //console.log("La respuesta es: " + this.answer);
       this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    },
    formatNPSInitial: function() {
      var x = this.$refs.options;
      //console.log(x);
      //var x = document.getElementsByClassName("label_nps_tigo");
      for (var i = x.length - 1; i >= 0; i--) {
        //console.log(x[i].className);
        if (i > 2) {
          x[i].className = "label_nps_1";
        } else if (i > 1) {
          x[i].className = "label_nps_2";
        } else {
          x[i].className = "label_nps_3";
        }
      }
    },
    clickNaText: function(){
      //console.log(this.checked);
      if(this.checked == false){
        this.visible = true;
        this.formatNPSInitial();
      }
      else{
        this.visible = false;
        this.answer = 'NA';
      }
      this.$emit("emit-value", { "q_id": this.question.q_id, "q_type": this.question.q_type, "ans": this.answer });
    }
  },
  mounted: function() {
    this.formatNPSInitial();
  }
};
</script>

<style lang="scss" scoped>
  .label_nps_tigo{
    text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(6, 7, 32, 0.8);
}

.nps_label{
    font-size: small;
    color: #b1b1b1;
    font-style: italic;
    margin:0px;
    display: inline-block;
    padding: 0;
    width: 50%;
}

.label_nps_selected{
       text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(162, 162, 162, 0.8);
}

.label_nps_1{
       text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(100, 255, 147, 0.8);
}


.label_nps_2{
       text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(255, 209, 43, 0.83);
}

.label_nps_3{
       text-align: center;
    float: left;
    color: #fff;
    font-size: 0.9em;
    height: auto;
    border: 1px solid #1d5073;
    margin: 0;
    /* padding: 10px; */
    padding-top:10px;
    padding-right:4px;
    padding-bottom:10px;
    padding-left:4px;
    -moz-border-radius: 5px;
    /* -webkit-border-radius: 5px; */
    /* border-radius: 5px; */
    background: rgba(255, 43, 100, 0.9);
}
</style>
